import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function MapCard({ map }) {
  const totalVotes = map.votesA + map.votesB;
  const pctA = totalVotes > 0 ? Math.round((map.votesA / totalVotes) * 100) : 50;
  const pctB = 100 - pctA;

  return (
    <motion.div 
      whileHover={{ y: -5, scale: 1.02 }}
      className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all group"
    >
      <Link to={`/map/${map.id}`} className="block">
        <div className="p-5">
          <div className="flex justify-between items-start mb-4">
            <div>
              <span className="text-xs font-bold uppercase tracking-wider text-slate-400 bg-slate-800 px-2 py-1 rounded">
                {map.region}
              </span>
              <h3 className="text-xl font-black mt-2 uppercase italic leading-tight group-hover:text-glow transition-all">
                {map.title}
              </h3>
            </div>
          </div>

          <div className="flex items-center justify-between mb-4 mt-6">
            <div className="flex flex-col items-center">
              <img src={map.optionA.image} alt={map.optionA.name} className="w-12 h-12 rounded-full border-2 object-cover" style={{ borderColor: map.optionA.color }} />
              <span className="text-xs font-bold mt-1" style={{ color: map.optionA.color }}>{map.optionA.name}</span>
            </div>
            <div className="text-slate-500 font-black italic text-lg tracking-tighter">VS</div>
            <div className="flex flex-col items-center">
              <img src={map.optionB.image} alt={map.optionB.name} className="w-12 h-12 rounded-full border-2 object-cover" style={{ borderColor: map.optionB.color }} />
              <span className="text-xs font-bold mt-1" style={{ color: map.optionB.color }}>{map.optionB.name}</span>
            </div>
          </div>

          {/* Live Progress Bar */}
          <div className="h-4 w-full bg-slate-800 rounded-full overflow-hidden flex">
            <motion.div 
              initial={{ width: 0 }}
              animate={{ width: `${pctA}%` }}
              className="h-full flex items-center justify-start px-2 text-[10px] font-bold text-slate-950"
              style={{ backgroundColor: map.optionA.color }}
            >
              {pctA > 15 && `${pctA}%`}
            </motion.div>
            <motion.div 
              initial={{ width: 0 }}
              animate={{ width: `${pctB}%` }}
              className="h-full flex items-center justify-end px-2 text-[10px] font-bold text-slate-950"
              style={{ backgroundColor: map.optionB.color }}
            >
              {pctB > 15 && `${pctB}%`}
            </motion.div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}